var DC_SizeGuide = {
    drawerID : 'drawer-size-guide',
    
    toggleView : function() {
        if (document.getElementsByTagName('body')[0].classList.contains('drawer-sizing-guide--isVisible')) {
            document.getElementsByTagName('body')[0].classList.remove('drawer-sizing-guide--isVisible')
        } else {
            document.getElementsByTagName('body')[0].classList.add('drawer-sizing-guide--isVisible')
        }
    },

    scrollToHowToMeasure : function() {
        var elementTop = document.querySelectorAll('#model-cards')[0].offsetTop;
        var divTop = document.querySelectorAll('#drawer-size-guide .drawer-size-guide__body')[0].offsetTop;
        var elementRelativeTop = elementTop - divTop;
        
        var whiteSpace = 570;

        if (window.outerWidth <= 375) {
            whiteSpace = 390;
        } else if (window.outerWidth <= 425) {
            whiteSpace = 480;
        } else if (window.outerWidth <= 768) {
            whiteSpace = 600;
        }

        document.querySelectorAll('#drawer-size-guide .drawer-size-guide__body')[0].scrollTop = elementRelativeTop - whiteSpace;
    }
}
